module.exports = __webpack_public_path__ + "img/techies.5df8e611.png";